<div class="registration-with-code-qrcode-combined">

    <sc-flex [vertical]="true" [stretchContent]="true">
      <sc-padding>
          <h1>{{'Code aus Voranmeldung' | translate:
              ['tmc-yard.widgets.registration-terminal.transport-registration-with-code.headline',
              translationService.language]}}</h1>
      </sc-padding>

      <sc-flex [stretchContent]="true" [fitHeight]="true">
        <sc-flex-fitting-content>
          <sc-padding>
            <div *ngIf="!qrCodeScanEnabled">
              {{'' | translate: ['tmc-yard.widgets.registration-terminal.transport-registration-with-code.description',
                translationService.language]}}
            </div>

            <div *ngIf="qrCodeScanEnabled">
              {{'' | translate: ['tmc-yard.widgets.registration-terminal.transport-registration-with-code.description-with-scanning',
                translationService.language]}}
            </div>

            <h2>{{'' | translate:
                  ['tmc-yard.widgets.registration-terminal.transport-registration-with-code.code.headline',
                  translationService.language]}}</h2>

            <form [formGroup]="registrationForm" class="form">
              <mat-form-field class="registration-code">
                <input matInput #focusComponent placeholder="Code" formControlName="code" autofocus>
              </mat-form-field>
            </form>

            <app-service-response [responseMessages]="responseMessages"></app-service-response>
            <ng-container *ngIf="validationMessage != null">
              <h2>{{validationMessage.message | translate: [validationMessage.message, translationService.language]}}</h2>
              <sc-content-spacer [vertical]="true"></sc-content-spacer>
            </ng-container>
            <mat-spinner class="progressSpinner" *ngIf="checkCodeActive"></mat-spinner>

          </sc-padding>
        </sc-flex-fitting-content>

        <div *ngIf="qrCodeScanEnabled">
          <sc-padding>
            <div class="qrcode" *ngIf="scannerType != 'webcam'">
              <img src="/assets/default/terminal_scan_qrcode_2.svg">
              <div class="diode">
                <div class="laser"></div>
              </div>
            </div>

            <div class="qrcode" *ngIf="scannerType === 'webcam' && webCamScannerEnabled">
              <zxing-scanner #scanner [enable]="webCamScannerEnabled"
                    [device]="deviceCurrent"
                    [autostart]="true"
                    (camerasFound)="camerasFoundHandler($event)"
                    (permissionResponse)="onCameraPermission($event)"
                    (deviceChange)="onCameraDeviceChanged($event)"
                    (scanSuccess)="scanSuccessHandler($event)"
                    (scanError)="scanErrorHandler($event)"
                    (scanComplete)="scanCompleteHandler($event)"></zxing-scanner>
            </div>
          </sc-padding>
        </div>

      </sc-flex>

      <div *ngIf="newRegistrationEnabled">
          <p>{{'' | translate:
              ['tmc-yard.widgets.registration-terminal.transport-registration-with-code.code.subline',
              translationService.language]}}</p>
      </div>

    </sc-flex>


</div>
